module.exports = __webpack_public_path__ + "static/media/IMG-2.4653197d.jpg";